import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  clearItemToItinerary,
  getCargoItemByItinerary,
} from '../../../../actions';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import Table from '../../../common/Table';

export class UnloadingCargoResult extends Component {
  componentWillUnmount() {
    this.props.dispatchClearItemToItinerary();
  }

  render() {
    const {
      loading,
      cargoItems,
      searchFormValues,
      dispatchGetCargoItemByItinerary,
      columns,
    } = this.props;

    const data = cargoItems.get('content') || [];
    const pages = cargoItems.get('totalPages') || null;
    const defaultPageSize = cargoItems.get('size') || DEFAULT_PAGE_SIZE;

    return (
      <div className="mt-3">
        <Table
          columns={columns}
          data={data}
          pages={pages}
          defaultPageSize={defaultPageSize}
          loading={loading}
          fetchData={dispatchGetCargoItemByItinerary}
          params={searchFormValues}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ CargoUnit }) => ({
  loading: !CargoUnit.ItemToItinerary.getIn(['current', 'activity']).isEmpty(),
  cargoItems: CargoUnit.ItemToItinerary.getIn(['current', 'items']),
});

const mapDispatchToProps = {
  dispatchGetCargoItemByItinerary: getCargoItemByItinerary,
  dispatchClearItemToItinerary: clearItemToItinerary,
};

UnloadingCargoResult.propTypes = {
  cargoItems: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  dispatchClearItemToItinerary: PropTypes.func.isRequired,
  searchFormValues: PropTypes.shape({
    itineraryId: PropTypes.number,
  }).isRequired,
  dispatchGetCargoItemByItinerary: PropTypes.func.isRequired,
  columns: PropTypes.instanceOf(Array).isRequired,
};

UnloadingCargoResult.defaultProps = {
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UnloadingCargoResult);
